import React, { useState } from 'react';
import { Plus, Minus, HelpCircle } from 'lucide-react';
const faqs = [{
  q: '¿Y si soy principiante?',
  a: 'El sistema está pensado para adaptarse por nivel. Podés empezar desde bases simples y progresar.'
}, {
  q: '¿Sirve si juego de defensora?',
  a: 'Sí. Incluye tácticas y entrenamientos específicos para defensoras.'
}, {
  q: '¿Sirve si juego de atacante?',
  a: 'Sí. Incluye movimientos ofensivos, definición, desmarques y presión alta.'
}, {
  q: '¿Necesito gimnasio?',
  a: 'No necesariamente. Hay ejercicios adaptables con cancha, conos, bocha, palo y peso corporal.'
}, {
  q: '¿Es solo teoría?',
  a: 'No. Está pensado como recurso práctico con ejercicios, drills, planes y tácticas listas para usar.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#1a2e1a]" data-id="element-68">
      <div className="max-w-3xl mx-auto" data-id="element-69">
        <div className="text-center mb-12" data-id="element-70">
          <div className="inline-flex items-center gap-2 text-[#c8e6c9] text-xs font-bold uppercase tracking-widest mb-3" data-id="element-71">
            <HelpCircle className="w-4 h-4" data-id="element-72" /> Dudas frecuentes
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#faf5e8]" data-id="element-73">
            Lo que están preguntando antes de comprar
          </h2>
        </div>

        <div className="space-y-3" data-id="element-74">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-[#223322] rounded-xl border transition-all overflow-hidden ${isOpen ? 'border-[#c8e6c9]/40' : 'border-green-800/40 hover:border-[#c8e6c9]/30'}`} data-id="element-75">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full flex items-center justify-between gap-4 p-5 text-left" data-id="element-76">
                  <span className="font-heading font-bold text-[#faf5e8] text-base md:text-lg" data-id="element-77">
                    {faq.q}
                  </span>
                  <div className="flex-shrink-0 w-7 h-7 rounded-full bg-[#2e7d32]/20 flex items-center justify-center" data-id="element-78">
                    {isOpen ? <Minus className="w-4 h-4 text-[#c8e6c9]" data-id="element-79" /> : <Plus className="w-4 h-4 text-[#c8e6c9]" data-id="element-80" />}
                  </div>
                </button>
                {isOpen && <div className="px-5 pb-5" data-id="element-81">
                    <div className="pt-1 text-[#d4d0c4] text-[15px] leading-relaxed border-t border-green-800/30" data-id="element-82">
                      <p className="pt-3" data-id="element-83">{faq.a}</p>
                    </div>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}